var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmbedLg = function SvgEmbedLg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#fff",
    "aria-hidden": "true",
    className: "embed-lg_svg__pbs-component-embed",
    viewBox: "0 0 275.26 183.09"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144.05 2.3a2.88 2.88 0 0 1 3.4-2.24L163 3.28a2.88 2.88 0 0 1 2.22 3.4l-36.11 174.11a2.88 2.88 0 0 1-3.39 2.24l-15.52-3.22a2.88 2.88 0 0 1-2.22-3.4zM30.72 88.24l61.1-61.1a2.88 2.88 0 0 0 0-4.07l-12-12a2.88 2.88 0 0 0-4.07 0L.84 86a2.88 2.88 0 0 0 0 4.07l.16.16a2.85 2.85 0 0 0 .69 1.11l74.92 74.92a2.88 2.88 0 0 0 4.07 0l12-12a2.87 2.87 0 0 0 0-4.07zm213.52 0-61.68-61.7a2.88 2.88 0 0 1 0-4.07l12.14-12.13a2.88 2.88 0 0 1 4.07 0L274.42 86a2.88 2.88 0 0 1 0 4.07l-.17.17a2.84 2.84 0 0 1-.69 1.12L197.9 167a2.88 2.88 0 0 1-4.07 0l-12.13-12.15a2.88 2.88 0 0 1 0-4.07z",
    className: "embed-lg_svg__cls-1"
  })));
};
export default SvgEmbedLg;